import { Stack } from '@mui/material'
import { useGetDailyShifts } from 'hook/query/useGetDailyShifts'
import { ShiftOptions } from 'models/ICattlesData'
import { IMilkingProcessGraph } from 'models/MilkingProcess'
import { FC, useMemo } from 'react'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface DeviationIndicatorsProps {
	milkingGraph?: IMilkingProcessGraph
}

const SHIFT_INDICATORS: {
	key: ShiftOptions
	label: string
	getValue: (graph?: IMilkingProcessGraph) => number | null | undefined
}[] = [
	{
		key: ShiftOptions.AM,
		label: 'За утреннюю смену',
		getValue: graph => graph?.am_count,
	},
	{
		key: ShiftOptions.PM,
		label: 'За дневную смену',
		getValue: graph => graph?.pm_count,
	},
	{
		key: ShiftOptions.NIGHT,
		label: 'За ночную смену',
		getValue: graph => graph?.night_count,
	},
]

const DeviationIndicators: FC<DeviationIndicatorsProps> = props => {
	const { milkingGraph } = props
	const { data: availableShifts = [] } = useGetDailyShifts({})

	const shifts = useMemo(() => {
		const availableKeys = new Set(availableShifts.map(shift => shift.value))
		return SHIFT_INDICATORS.filter(shift => availableKeys.has(shift.key)).map(
			shift => ({
				label: shift.label,
				value: shift.getValue(milkingGraph),
			}),
		)
	}, [availableShifts, milkingGraph])

	if (!shifts.length) return null

	return (
		<Stack direction='row' gap='24px'>
			{shifts.map(shift => {
				const isNoData = shift.value === null || shift.value === undefined
				const displayValue = isNoData
					? '-'
					: Number(shift.value).toLocaleString()

				return (
					<Stack key={shift.label} direction='column' gap='4px'>
						<TypographySecondary>Итого за период</TypographySecondary>
						<TypographyPrimary16Bold>{displayValue}</TypographyPrimary16Bold>
						<TypographySecondary>{shift.label}</TypographySecondary>
					</Stack>
				)
			})}
		</Stack>
	)
}

export default DeviationIndicators
